// @generated by tools/docgen — do not edit.
// Source: docs/examples/carousel.md

import React from 'react';
import { CarouselDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function CarouselPage() {
  return (
    <ExampleLayout title="rx fields" demo={<CarouselDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          This example shows how an rx field can be used as a bare str or int. They are indeed extensions of int and str. NOTE: bool type cannot be extended. rx[bool] fields cannot be used with is comparison.
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-carousel-backend">
        <ExampleSectionHeading id="examples-carousel-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="carousel/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-carousel-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-carousel-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="carousel/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default CarouselPage;
